import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { modalId: String }

  submitStart() {
    this.closeModal()
  }

  submitEnd(event) {
    if (!event.detail.success) return

    this.closeModal()
  }

  closeModal() {
    const modal = this.modalElement()
    if (!modal) return

    if (modal instanceof HTMLDialogElement) {
      if (modal.open) modal.close()
      return
    }

    modal.classList.add("hidden")
    modal.classList.remove("flex")
    modal.classList.remove("block")
    modal.setAttribute("aria-hidden", "true")
    modal.removeAttribute("aria-modal")

    document.body.classList.remove("overflow-hidden")
    document.body.classList.remove("md:overflow-hidden")
    document.body.classList.remove("overflow-y-hidden")

    document.querySelectorAll("[modal-backdrop], [data-modal-backdrop], .modal-backdrop").forEach((el) => el.remove())
  }

  modalElement() {
    if (this.hasModalIdValue) {
      return document.getElementById(this.modalIdValue)
    }

    return this.element.closest("[id]")
  }
}
